
import React from "react";
import { useFormContext } from "react-hook-form";
import { 
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormValues } from "./FormSchema";

const RentalDetailsFields: React.FC = () => {
  const { control } = useFormContext<FormValues>();
  
  return (
    <div className="bg-gray-50 p-4 rounded-md">
      <h3 className="font-bold text-lg mb-4">Détails de la location</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={control}
          name="typeBenne"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Type de benne</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Sélectionnez un type" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="8m3">Benne 8m³</SelectItem>
                  <SelectItem value="10m3">Benne 10m³</SelectItem>
                  <SelectItem value="15m3">Benne 15m³</SelectItem>
                  <SelectItem value="20m3">Benne 20m³</SelectItem>
                  <SelectItem value="30m3">Benne 30m³</SelectItem>
                  <SelectItem value="fermee">Benne fermée</SelectItem>
                  <SelectItem value="compacteur">Compacteur</SelectItem>
                  <SelectItem value="autres">Autres (préciser en commentaire)</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="typeDechet"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Type de déchets</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Sélectionnez le type de déchet" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="gravats">Gravats et matériaux de construction</SelectItem>
                  <SelectItem value="dechets-verts">Déchets verts (élagage, tonte)</SelectItem>
                  <SelectItem value="tout-venant">Tout-venant (déchets ménagers)</SelectItem>
                  <SelectItem value="dib">DIB (Déchets Industriels Banals)</SelectItem>
                  <SelectItem value="encombrants">Encombrants (meubles, électroménager)</SelectItem>
                  <SelectItem value="bois">Bois (palettes, charpentes)</SelectItem>
                  <SelectItem value="metaux">Métaux ferreux et non ferreux</SelectItem>
                  <SelectItem value="cartons">Cartons et papiers</SelectItem>
                  <SelectItem value="plastiques">Plastiques et emballages</SelectItem>
                  <SelectItem value="autres">Autres (préciser en commentaire)</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <FormField
          control={control}
          name="jours"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Nombre de jours</FormLabel>
              <FormControl>
                <Input type="number" min="1" placeholder="7" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="dateDebut"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Date de début</FormLabel>
              <FormControl>
                <Input type="date" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={control}
        name="commentaire"
        render={({ field }) => (
          <FormItem className="mt-4">
            <FormLabel>Commentaires ou précisions</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Indiquez ici toute information complémentaire utile à votre demande..." 
                className="min-h-[100px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default RentalDetailsFields;
